import "./button.scss";

export default function Button({ children, isLoading, ...rest }) {
  return (
    <button className="button" {...rest}>
      { isLoading ? <span>Loading...</span> : children}
    </button>
  );
}
